<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.tel" 
[label]="step1.gettel"
[type]="'text'"
[rule]="'pattern_8|minSize_10|maxSize_15'"
[errorMessage]="{'pattern' : 'ctr_208', 'minLength' : 'ctr_208_longueur'}"
[name]="getUid()+'_SepAtt_tel'">
</app-form-input>

<app-form-input *ngIf="formName !== 'DIVE_AT'"
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.poste" 
[label]="step1.getposte"
[type]="'text'"
[rule]="''"
[name]="getUid()+'_SepAtt_poste'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.fax" 
[label]="step1.getfax"
[type]="'text'"
[rule]="'pattern_8|minSize_10|maxSize_15'"
[errorMessage]="{'pattern' : 'ctr_209', 'minLength' : 'ctr_209_longueur'}"
[name]="getUid()+'_SepAtt_fax'">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
[value]="coord?.mel" 
[label]="step1.getmel"
[type]="'text'"
[rule]="'pattern_1|maxSize_200'"
[errorMessage]="{'pattern' : 'ctr_117'}"
[name]="getUid()+'_SepAtt_mel'">
</app-form-input>
